import { CardsTableHeadArrowDown } from './CardsTableHeadArrowDown';
export default CardsTableHeadArrowDown;
